'use client';

import { useEffect, useRef } from 'react';
import analytics from '@/services/analytics';
import type { GtmEventParams } from '@/services/analytics/plugins/analyticsJucyEcommerce';

export function AnalyticsTrackEcommerceItem({ item_list_id, item_list_name, items }: GtmEventParams) {
    const hasTriggeredEvent = useRef(false);
    useEffect(() => {
        if (hasTriggeredEvent.current || !items?.length) {
            return;
        }
        hasTriggeredEvent.current = true;
        analytics.plugins.ecommerce.trackEcommerce(items?.length === 1 ? 'view_item' : 'view_item_list', {
            item_list_id,
            item_list_name,
            items,
        });
    }, [item_list_id, item_list_name, items]);
    return null;
}
